<template><canvas ref="canvas" aria-label="歪脖鸡皮油" /></template>
<script>
import Factory from './game/Factory'
export default {
  name: 'App',
  mounted() { this.game = new Factory(this.$refs.canvas) },
  beforeDestroy() { this.game.destroy() }
}
</script>
